export default function Codes() {
  return <div>Codes</div>;
}
